import produce from "immer";
import { IStoreState } from "../../initialStoreState";

import { LoadState } from "../../../constants/enums";
import { CLEAR_BANK_DEBIT_CREDIT_STATEMENTS, FETCH_BANK_DEBIT_CREDIT_LIST_FAILED, FETCH_BANK_DEBIT_CREDIT_LIST_PROGRESS, FETCH_BANK_DEBIT_CREDIT_LIST_SUCCESS, FETCH_GL_DETAILS_LIST_FAILED, FETCH_GL_DETAILS_LIST_PROGRESS, FETCH_GL_DETAILS_LIST_SUCCESS } from "./BankDebitCreditActions";
import { initialBankCreditDebitState } from "./BankDebitCredit.types";
import { BankDebitCreditActions } from ".";

export const bankCreditDebitReducer = (
  state: IStoreState["accounting"]["bankCreditDebit"] = initialBankCreditDebitState,
  action: BankDebitCreditActions
) => {
  switch (action.type) {
    case FETCH_BANK_DEBIT_CREDIT_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.list = [];
        draftState.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_BANK_DEBIT_CREDIT_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.list = data;
        draftState.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_BANK_DEBIT_CREDIT_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.list = [];
        draftState.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_GL_DETAILS_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.glDetailLoading = LoadState.InProgress;
        draftState.glDetail = [];
      });
      return newState;
    }
    case FETCH_GL_DETAILS_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.glDetailLoading = LoadState.Loaded;
        draftState.glDetail = data;
      });
      return newState;
    }
    case FETCH_GL_DETAILS_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.glDetailLoading = LoadState.Failed;
        draftState.glDetail = [];
      });
      return newState;
    }

    case CLEAR_BANK_DEBIT_CREDIT_STATEMENTS: {
      return initialBankCreditDebitState;
    }

    default: {
      return state;
    }
  }
};
